import map from "lodash/map";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getKjoretoyMerker } from "../../../actions/kjoretoyMerkerActions";
import * as title from "../../../constants/titles";
import Table from "../../Common/Tables/BaseTable";
import KjoretoyMerkerModal from "./UpdateModals/KjoretoyMerkerModal";

export default function KjoretoyMerkerList({ authorizedToCreateAndEdit }) {
  const kjoretoyMerker = useSelector((state) => state.kjoretoyMerker);
  const dispatch = useDispatch();

  useEffect(() => {
    document.title = title.grunndataKjoretoyMerker;
    dispatch(getKjoretoyMerker());
  }, [dispatch]);

  const headerRow = ["Kode", "Merke", ""];
  return (
    <div className="table-wrapper-horizontal-scroll">
      <Table id="kjoretoyMerke-liste" headerRow={headerRow} defaultStyle striped>
        <tbody>
          {map(kjoretoyMerker, (kjoretoyMerke) => (
            <tr key={`kjoretoyMerkerTableBodyTr${kjoretoyMerke.id.toString()}`}>
              <td>{kjoretoyMerke.kode}</td>
              <td>{kjoretoyMerke.merke}</td>
              <td>
                {authorizedToCreateAndEdit && (
                  <KjoretoyMerkerModal kjoretoyMerke={kjoretoyMerke} />
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}
